<template>
  <div v-if="ShowTableView">
    <chart-table
      :headers="TableSettings.headers"
      :rows="TableSettings.rows"
      :Elements="TableSettings.Elements"
    ></chart-table>
  </div>
  <div v-else ref="root" :class="$style['adl-bar-chart']">
    <adl-chart-bar
      :data="chartData"
      :rangeX="chartProperties.rangeX"
      :rangeY="chartProperties.rangeY"
      :domainX="chartProperties.domainX"
      :domainY="chartProperties.domainY"
      :tickQuantityY="chartProperties.tickQuantityY"
      :yAxisLabel="chartProperties.yAxisLabel"
      :color="chartProperties.color"
      :legendItems="chartProperties.legendItems"
      :legendKeyType="chartProperties.legendKeyType"
      :currencyFormat="chartProperties.currencyFormat"
      :height="chartProperties.height"
      :tickX="chartProperties.tickX"
      :axisLeftWidth="chartProperties.axisLeftWidth"
      :axisRightWidth="chartProperties.axisRightWidth"
      :isHideFirstTick="chartProperties.isHideFirstTick"
      :linePlotData="linePlotData"
      :lineColor="chartProperties.lineColor"
      @setTooltipData="setTooltipData"
    >
      <template v-slot:tooltipText>
        <mce-hover-flag
          v-if="mouse"
          :x="mouse.pageX"
          :y="mouse.pageY"
          :style="hoverStyle"
        >
          <div ref="hover" :style="tooltipBoxWidth">
            <mce-legend hide-top-border hide-bottom-border>
              <mce-legend-group :title="tooltipmouseDataBar.title">
                <mce-legend-item
                  v-for="(d, i) in toolBarData"
                  :key="i"
                  :color="toolBarColor[i]"
                  :class="$style[d.class]"
                  :label="toolBarHeading[i]"
                  :value="d.formatedValue"
                  :key-type="d.hideKeyType ? '' : 'bar'"
                ></mce-legend-item>
              </mce-legend-group>
            </mce-legend>
          </div>
        </mce-hover-flag>
      </template>
    </adl-chart-bar>
  </div>
</template>
<script>
import AdlChartBar from "../custom/chart-bar/ChartBar.vue";
import { MceLegend, MceLegendItem, MceLegendGroup } from "@mce/legend";
import { CommonHelper } from "../../helpers";
import MceHoverFlag from "@mce/hover-flag";
import { ChartToolTip } from "../../mixin";
import ChartTable from "./ChartTable.vue";
export default {
  props: {
    chartProperties: {
      type: Object,
    },

    chartData: {
      type: Array,
    },
    linePlotData: {
      type: Array,
    },
    TableSettings: {
      type: Object,
    },
    ShowTableView: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ChartToolTip],
  computed: {
    hoverStyle() {
      if (this.linePlotData && this.linePlotData.length > 0) {
        return { maxWidth: this.chartProperties.width + "px !important" };
      } else {
        return { maxWidth: this.defaultWidth + "px" };
      }
    },
    tooltipBoxWidth() {
      if (this.linePlotData && this.linePlotData.length > 0) {
        return { width: this.chartProperties.width - 30 + "px !important" };
      } else {
        return { width: this.defaultWidth - 30 + "px !important" };
      }
    },
  },
  components: {
    AdlChartBar,
    MceLegend,
    MceLegendItem,
    MceLegendGroup,
    MceHoverFlag,
    ChartTable,
  },
  data() {
    return {
      tooltipmouseDataBar: {},
      defaultWidth: 200,
      toolBarData: [],
      toolBarHeading: this.chartProperties.legendItems,
      toolBarColor: [],
      mouse: null,
      padding: 20,
      emptyColor: "#FFFFFF",
    };
  },
  methods: {
    async setTooltipData(data, mouse) {
      this.tooltipmouseDataBar = Object.assign({}, data);
      this.mouse = mouse;
      this.toolBarData = [];
      this.toolBarHeading = [];
      if (this.tooltipmouseDataBar.toolBarData) {
        this.toolBarData = this.tooltipmouseDataBar.toolBarData;
        this.toolBarHeading = this.getToolTipHeading(this.toolBarData);
        this.toolBarColor = this.getToolTipBarColor(this.toolBarData);
      } else {
        this.toolBarData = this.tooltipmouseDataBar.value;
        this.toolBarHeading = this.chartProperties.legendItems;
        this.toolBarColor = this.chartProperties.color;
      }
      if (this.toolBarData) {
        for (let i = 0; i < this.toolBarData.length; i++) {
          this.toolBarData[i].formatedValue =
            CommonHelper.convertIntoCurrencyWithoutDecimal(
              this.toolBarData[i].value
            );
        }
      }
      let tooltipWidth = this.chartProperties.width
        ? this.chartProperties.width
        : this.defaultWidth;
      if (this.mouse && this.mouse.pageY) {
        if (window.innerWidth - tooltipWidth < this.mouse.pageX) {
          this.mouse.pageX = window.innerWidth - tooltipWidth;
        }
        await this.resetToolTipHeight(this.padding);
      }
    },
    getToolTipHeading(data) {
      let toolBarHeading = [];
      for (let i = 0; i < data.length; i++) {
        toolBarHeading.push(data[i].id);
      }
      return toolBarHeading;
    },
    getToolTipBarColor(data) {
      let toolBarColor = this.chartProperties.color;
      for (let i = this.chartProperties.color.length; i < data.length; i++) {
        toolBarColor.push(this.emptyColor);
      }
      return toolBarColor;
    },
  },
};
</script>
<style lang="scss" module>
.adl-bar-chart {
  .add-margin {
    margin-top: 10px;
  }
  .bold-text span {
    font-weight: bold;
  }
  .left-margin {
    padding-left: 10px;
  }
}
</style>
